import React from "react";
import { Link } from "gatsby";
import { PortableText } from "@portabletext/react";
import urlBuilder from "@sanity/image-url";
import { getImageDimensions } from "@sanity/asset-utils";
import ReactPlayer from "react-player/file";
import Embed from "./Embed";
import VimeoVideo from "./Vimeo";

export default function TextPortable({ data }) {
  const SampleImageComponent = ({ value, isInline }) => {
    const { width, height } = getImageDimensions(value);
    return (
      <img
        src={urlBuilder({
          dataset: "production",
          projectId: "3z6ewxon",
        })
          .image(value)
          .width(isInline ? 100 : 800)
          .fit("max")
          .auto("format")
          .url()}
        alt={value.alt || " "}
        loading="lazy"
        className="richText__image"
        style={{
          // Display alongside text if image appears inside a block text span
          display: isInline ? "inline-block" : "block",

          // Avoid jumping around with aspect-ratio CSS property
          aspectRatio: width / height,
        }}
      />
    );
  };

  const FileComponent = ({ value }) => {
    const arr = value?.video?.asset?._ref?.split("-");
    if (arr.length > 2) {
      let url = `https://cdn.sanity.io/files/3z6ewxon/production/${arr[1]}.${arr[2]}`;

      return (
        <div className="my-2">
          <ReactPlayer url={url} controls />;
        </div>
      );
    }
  };
  return (
    <PortableText
      value={data}
      components={{
        types: {
          image: SampleImageComponent,
          embedVideo: ({ value }) => {
            return <Embed data={value} />;
          },
          vimeoVideo: ({ value }) => {
            return <VimeoVideo data={value} />;
          },
          videoUpload: FileComponent,
        },
        marks: {
          link: ({ children, value }) => {
            const rel = !value.href?.startsWith("/")
              ? "noreferrer noopener"
              : undefined;

            if (value.href?.startsWith("/")) {
              return (
                <Link to={value.href} className="!text-green">
                  {children}
                </Link>
              );
            } else {
              return (
                <a
                  target="_blank"
                  href={value.href}
                  rel={rel}
                  className="!text-green"
                >
                  {children}
                </a>
              );
            }
          },
        },
      }}
    />
  );
}
